import React, {useEffect, useState} from "react";
import {
    IonButton,
    IonContent, IonHeader, IonIcon,
    IonLoading,
    IonPage, IonTitle, IonToolbar
} from "@ionic/react";

import {useMutation} from "@apollo/client";
import {
    ACA_GET_IMAGE_URL
} from "../../schemas/aca";
import {useHistory, useRouteMatch} from "react-router";
import {AcaHeader} from "./AcaHeader";
import useAuth from "../../hooks/useAuth";
import {cloudDownloadOutline, cloudDownloadSharp} from "ionicons/icons";

const AcaViewImage: React.FC<any> = () => {

    const {claims} = useAuth();
    const history = useHistory();
    const DEFAULT_LOADING_MESSAGE: string = 'Please wait...';
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [loadingMessage, setLoadingMessage] = React.useState<string>(DEFAULT_LOADING_MESSAGE);


    const [getImageUrlMutation] = useMutation(ACA_GET_IMAGE_URL);

    const match:any = useRouteMatch();
    const [tier1, setTier1] = React.useState<boolean>(false);
    const [tier2, setTier2] = React.useState<boolean>(false);
    const [manager, setManager] = React.useState<boolean>(false);
    const [imageUrl, setImageUrl] = React.useState<string | undefined>(undefined);
    const [fileType, setFileType] = React.useState<string | undefined>(undefined);

    useEffect(() => {
        // check for roles
        if (!claims.rules.includes('AcaView')) {
            history.push('/');
            return;
        }

        if (claims.rules.includes('AcaEditTier1') && !claims.rules.includes('AcaEditTier2') && !claims.rules.includes('AcaManager')) {
            history.push('/');
            return;
        }
        if (!claims.rules.includes('AcaEditTier2')) {
            history.push('/');
            return;
        } else {
            setTier2(true);
        }
        if (claims.rules.includes('AcaManager')) {
            setManager(true);
        }
        if (match.params.id && !isNaN(match.params.id)) {
            load(Number(match.params.id));
        }
    }, []);

    const load = async(id: number) => {
        const imageLookup = await getImageUrlMutation({variables: {imageId: id}});
        if (!imageLookup.data.acaGetImageUrl.success) {
            return alert('Unable to lookup image!');
        }
        setImageUrl(imageLookup.data.acaGetImageUrl.url);
        setFileType(imageLookup.data.acaGetImageUrl.fileType);
    };



    const downloadImage = async (imageSrc: string | undefined) => {
        // Create an invisible link element
        if (imageSrc) {
            const a = document.createElement('a');
            a.href = imageSrc;
            a.download = '';  // Browser will automatically infer the filename
            a.style.display = 'none';

            // Append the link to the document, trigger click, then remove the link
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };


    return (
        <IonPage>

            <AcaHeader pageTitle="ACA Contact Details"></AcaHeader>
            <IonLoading isOpen={isLoading} message={loadingMessage}/>
            <IonContent fullscreen className="aca-view-image">
                <div style={{padding: '10px'}}>
                    <div style={{textAlign: 'center'}}>
                        {(fileType?.toUpperCase() === 'PNG' || fileType?.toUpperCase() === 'JPG' || fileType?.toUpperCase() === 'JPEG') &&
                            <img style={{border: '1px solid black'}} id="myimage" src={imageUrl}/>
                        }
                        <br/>
                        <IonButton fill="outline" onClick={() => downloadImage(imageUrl)}><IonIcon md={cloudDownloadOutline} ios={cloudDownloadSharp}></IonIcon> Download Image</IonButton>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default AcaViewImage;